import React, { useCallback, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const LazyI18nProvider: React.FC<{ children: React.ReactNode; lng: string }> = ({ children, lng }) => {
  const [isLoading, setIsLoading] = useState(true);


  const checkInit = useCallback((resolve: () => void) => {
    if (i18n.isInitialized) {
      resolve();
    } else {
      setTimeout(() => checkInit(resolve), 50);
    }
  }, []);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        // Wait for i18n to be initialized
        if (!i18n.isInitialized) {
          await new Promise<void>((resolve) => {
            checkInit(resolve);
          });
        }

        // Use the detected language if available, otherwise use the provided lng
        const language = i18n.language || lng;

        // Change the language
        await i18n.changeLanguage(language);

        setIsLoading(false);
      } catch (error) {
        console.error('Failed to load translations:', error);
        setIsLoading(false);
      }
    };

    loadTranslations();
  }, [lng, checkInit]);

  if (isLoading) {
    return <div>Loading translations...</div>;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default LazyI18nProvider;